import './App.css';
import { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import DashboardHome from './routes/dashboard';
import UpdatePatch from './routes/dashboard/UpdatePatch';
import PatchDetails from './routes/PatchDetails';
import { BrowserRouter, Route, Routes } from "react-router"
import PatchNotes from './routes/PatchNotes';
import AddPatch from './routes/dashboard/AddPatch';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './utils/ProtectedRoute';
import Login from './routes/Login';
import { useLanguage } from './contexts/LanguageContext';
import { ToastContainer } from 'react-toastify';
import Register from './routes/Register';
import AdminProtectedRoute from './utils/AdminProtectedRoute';
import UsersTable from './routes/Admin/UsersTable';
import NotFound from './routes/NotFound';
import { AnimatePresence, motion } from 'framer-motion';
import { FaGhost } from 'react-icons/fa';
import { GiGhost, GiHangingSpider, GiSpiderWeb } from 'react-icons/gi';
import { RxDividerVertical } from 'react-icons/rx';

function App() {
    const { language, t } = useLanguage();
    const [show, setShow] = useState(false);
 
    useEffect(() => {
        document.documentElement.lang = language;
        document.title = t('title')
    }, [language, t]);

    useEffect(() => {
        setShow(true)
    }, [])

    useEffect(() => {
    if (show) {
            const timer = setTimeout(() => {
                setShow(false);
            }, 1400);
            return () => clearTimeout(timer);
        }
    }, [show]);

    return (
        <div className="App">
                <BrowserRouter>
                    <AuthProvider>
                        <Navbar />
                        <ToastContainer position="top-right" autoClose={3000} theme="colored" />
                        <div>
                            <GiSpiderWeb className='text-5xl absolute top-0 text-gray-300 z-40' />
                            <GiSpiderWeb className='text-5xl absolute top-0 right-0 text-gray-300 z-40' />
                        </div>
                        {show && (
                            <AnimatePresence>
                                {show && (
                                    <motion.div
                                        initial={{ scale: 0, x: -200, y: 200, opacity: 0 }}
                                        animate={{ scale: 2, x: 0, y: 0, opacity: 0.8 }}
                                        exit={{ scale: 0.5, // KÜÇÜLME EFEKTİ EKLENDİ
                                        x: 200, // SAĞA KAYMA
                                        y: -200, // YUKARI KAYMA EFEKTİ EKLENDİ
                                        opacity: 0, }}
                                        transition={{ duration: 1.4, ease: "easeInOut" }}
                                        className="fixed top-[40%] left-[40%] text-9xl z-50"
                                    >
                                        <GiGhost />
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        )}
                        <Routes>
                            <Route path='/' element={<PatchNotes />} />
                            <Route path="/patch/:patchNo" element={<PatchDetails />} />
                            <Route path="/login" element={<Login />} />
                            <Route path='/register' element={
                                <AdminProtectedRoute>
                                    <Register />
                                </AdminProtectedRoute>
                            } />
                            <Route path="/users" element={
                                <AdminProtectedRoute>
                                    <UsersTable />
                                </AdminProtectedRoute>
                            } />
                            
                            <Route path="/dashboard" element={
                                <ProtectedRoute>
                                    <DashboardHome />
                                </ProtectedRoute>
                            } />

                            <Route path="/dashboard/add-patch" element={
                                <ProtectedRoute>
                                    <AddPatch />
                                </ProtectedRoute>
                            } />

                            <Route path="/dashboard/update-patch/:patchNo" element={
                                <ProtectedRoute>
                                    <UpdatePatch />
                                </ProtectedRoute>
                            } />

                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </AuthProvider>
                </BrowserRouter>
        </div>
    );
}

export default App;